import { Text, Badge, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface CarPoolingCardProps {
  data?: any;
}

const CarPoolingCard = ({ data }: CarPoolingCardProps) => {
  const colors = useBinderCardColors();

  // Get processed vehicles data
  const vehicles = data?.vehicles || [];

  const formatCarPoolingStatus = (isCarPooling: any) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {isCarPooling ? 'Yes' : 'No'}
      </Badge>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows = vehicles.map((vehicle: any) => {
    return [
      vehicle.name,
      formatCarPoolingStatus(vehicle.isCarPooling),
      vehicle.remarks ? (
        <Text fontSize="sm">{formatSimpleValue(vehicle.remarks)}</Text>
      ) : (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          No remarks
        </Text>
      ),
      <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = ['Vehicle', 'Car Pooling', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Are any vehicles on the application used for car pooling?"
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default CarPoolingCard;
